import React from "react";
import { EXPRESSION_LABELS } from "../../../constants/expressionBuilder.constants";
import "../../../styles/ExpressionBuilder.css";
import GroupComponent from "../../GroupComponent/GroupComponent";

/**
 * Component for rendering the expression builder section
 * @param {Object} expression - Current expression object
 * @param {Function} updateRootExpression - Function to update root expression
 * @param {Array} availableFields - Available workflow variables
 * @param {Object} fieldValidators - Validation functions for fields
 * @returns {JSX.Element} Expression builder section component
 * @author Abhishek Dhillon
 * @parent ModalBody
 */
const ExpressionBuilderSection = ({ expression, updateRootExpression, availableFields, fieldValidators = {} }) => {
  /**
   * Renders the no variables available message
   * @returns {JSX.Element} No variables alert
   * @author Abhishek Dhillon
   */
  const renderNoVariablesAlert = () => (
    <div className='expression-builder-alert expression-builder-alert-info'>
      <strong>{EXPRESSION_LABELS.NO_VARIABLES_AVAILABLE}</strong>
      <p className='mb-0'>{EXPRESSION_LABELS.NO_VARIABLES_MESSAGE}</p>
    </div>
  );

  /**
   * Renders the main expression builder content
   * @returns {JSX.Element} Expression builder content
   * @author Abhishek Dhillon
   */
  const renderBuilderContent = () => {
    if (availableFields?.length > 0) {
      return (
        <GroupComponent
          group={expression}
          onUpdate={updateRootExpression}
          availableFields={availableFields}
          isRoot={true}
          fieldValidators={fieldValidators}
        />
      );
    }
    return renderNoVariablesAlert();
  };

  return (
    <div className='col-lg-12 expression-builder-column-left'>
      <h6 className='expression-builder-mb-3'>{EXPRESSION_LABELS.EXPRESSION_BUILDER}</h6>
      <div className='expression-builder-scroll-container-left expression-builder-scroll'>{renderBuilderContent()}</div>
    </div>
  );
};

export default ExpressionBuilderSection;
